import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useState } from "react";

function Navbar({ purchasedCount, wishlistCount }) {
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <Link to="/" className="nav-logo">
        <img src="/navbar.png" alt="BongoGames" className="nav-logo-img" />
      </Link>
      <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        <span className={`hamburger-bar ${menuOpen ? "open" : ""}`} />
        <span className={`hamburger-bar ${menuOpen ? "open" : ""}`} />
        <span className={`hamburger-bar ${menuOpen ? "open" : ""}`} />
      </button>
      <div className={`nav-links ${menuOpen ? "nav-links-open" : ""}`}>
        <Link to="/" onClick={() => setMenuOpen(false)}>Browse</Link>
        {user && (
          <>
            <Link to="/library" className="nav-link-with-badge" onClick={() => setMenuOpen(false)}>
              My Games {purchasedCount > 0 && <span className="badge">{purchasedCount}</span>}
            </Link>
            <Link to="/wishlist" className="nav-link-with-badge" onClick={() => setMenuOpen(false)}>
              Wishlist {wishlistCount > 0 && <span className="badge">{wishlistCount}</span>}
            </Link>
            {user.role === "developer" && (
              <Link to="/developer/dashboard" onClick={() => setMenuOpen(false)}>Dashboard</Link>
            )}
            {user.role === "admin" && (
              <Link to="/admin" className="nav-link-admin" onClick={() => setMenuOpen(false)}>Admin</Link>
            )}
          </>
        )}
        <div className="nav-auth">
          {user ? (
            <>
              <span className="nav-username">{user.username}</span>
              <button className="nav-logout-btn" onClick={() => { logout(); setMenuOpen(false); }}>
                Logout
              </button>
            </>
          ) : (
            <Link to="/login" className="nav-login-btn" onClick={() => setMenuOpen(false)}>Login</Link>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
